module.exports = __webpack_public_path__ + "static/media/TOGF_220.53c98d4a.png";